import React, { useState } from "react";
import { useContext } from "react";

import { Functions } from "../../Common";
import { Modal, Input, Button } from "antd";
import Services from "../../../Services/dataService";
import { HomeContext } from "../../Context";
const { Warning, Info } = Functions;
function SaveFilter({ modelVisible, setModelVisible, filter, setCurrentFilter }) {
	const [title, setTitle] = useState("");
	const [loading, setLoading] = useState(false);
	const { selectedPolygons, sliderValue } = useContext(HomeContext);

	const selectedSliderValue = sliderValue?.[selectedPolygons];
	return (
		<Modal
			title="Save Filter"
			visible={modelVisible}
			onCancel={() => setModelVisible(false)}
			footer={[
				<Button
					key="save"
					loading={loading}
					onClick={async () => {
						if (title.trim() === "") Warning("Title Requieq!");
						else {
							setLoading(true);
							let newFilter = await Services.saveFilter(
								filter,
								title,
								selectedSliderValue
									? {
											[selectedPolygons]: sliderValue?.[selectedPolygons]
									  }
									: {}
							);
							if (newFilter) {
								setCurrentFilter(newFilter);
								Info("Filter Saved Successfully!");
								setModelVisible(false);
							} else Warning("Something went wrong!");
						}
					}}
				>
					Save
				</Button>,
				<Button key="cancel" onClick={() => setModelVisible(false)}>
					Cancel
				</Button>
			]}
		>
			<h5>Enter Filter Title </h5>
			<Input
				type="text"
				value={title}
				placeholder={"Filter Title"}
				onChange={e => {
					const title = e.target.value;
					setTitle(title);
				}}
			/>
		</Modal>
	);
}

export default SaveFilter;
